import { Phone } from "iconoir-react"
import { settings } from "@/settings"

export default function LandingCallEmbed() {
  return (
    <div className="w-full bg-transparent flex justify-center py-8">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-lg text-center border border-gray-200">
        <div className="mx-auto w-fit p-3 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-xl shadow-lg mb-4">
          <Phone className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-2xl font-bold text-gray-800">Want to talk to our AI?</h2>
        <p className="text-base text-gray-600 mt-2 max-w-xl mx-auto">
          Experience the magic firsthand. Call our AI for a mind-bending conversation and a glimpse into the future of
          voice AI.
        </p>
        <div className="mt-6">
          <div className="inline-block bg-gray-100 rounded-lg px-4 py-3">
            <a
              href={`tel:${settings.DEMO_PHONE_NUMBER_TEL}`}
              className="text-xl font-mono text-gray-700 tracking-wider hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 rounded"
            >
              {settings.DEMO_PHONE_NUMBER}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
